import React from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Button} from "@mui/material";
import {AppDispatch} from "@store/store.tsx";
import {endCall, startCall} from "@store/callSlice.tsx";

const Ringer = () => {
    const {ticketId} = useSelector((state: any) => state.call)
    const dispatch = useDispatch<AppDispatch>();

    React.useEffect(() => {
        const audio = new Audio(require('@assets/phone_ring.mp3'))
        audio.loop = true
        audio.play()
        return () => {
            audio.pause()
        }
    }, [])

    const reject = () => {
        dispatch(endCall())
    }
    const accept = () => {
        dispatch(startCall())
    }
    return (
        <div className={"absolute bottom-[40px] md:bottom-[30px] right-0 z-10 w-[350px] bg-[#D7F3FF] h-[200px] shadow-lg flex flex-col"}>
            <div className={'flex-1 flex flex-col justify-center items-center'}>
                <span className={'text-zinc-600 text-sm'}>Ringing...</span>
                <span className={'text-3xl'}>Ticket {ticketId}</span>
            </div>
            <div className={'flex'}>
                <Button variant={"contained"} className={'w-full !rounded-none'} disableElevation
                        color={'error'} onClick={reject}>Reject</Button>
                <Button variant={"contained"} className={'w-full !rounded-none'} disableElevation
                        onClick={accept}>Accept</Button>
            </div>
        </div>
    );
};

export default Ringer;
